import { createIcon } from '@chakra-ui/react';

export const MbeUser = createIcon({
  displayName: 'MbeUser',
  viewBox: '0 0 64 64',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        d="M43.374 32.572c2.095-2.806 3.353-6.403 3.353-10.322C46.727 13.275 40.134 6 32 6s-14.727 7.275-14.727 16.25c0 3.92 1.258 7.516 3.353 10.322C16.78 33.893 14 37.482 14 41.75v6.5c0 5.385 4.395 9.75 9.818 9.75h16.364C45.605 58 50 53.635 50 48.25v-6.5c0-4.269-2.78-7.857-6.626-9.178zM20.545 22.25c0-7.18 5.129-13 11.455-13 6.326 0 11.455 5.82 11.455 13s-5.129 13-11.455 13c-6.326 0-11.455-5.82-11.455-13zm26.182 25.188c0 4.038-3.596 7.312-8.033 7.312H25.306c-4.437 0-8.033-3.274-8.033-7.313v-4.874c0-3.455 2.64-6.333 6.179-7.099C25.864 37.37 28.809 38.5 32 38.5c3.19 0 6.136-1.131 8.548-3.035 3.54.765 6.18 3.643 6.18 7.097v4.876z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
});
